import React from "react";
import imageOne from "../../resource/events/demonstration/2.png";
import imageTwo from "../../resource/events/demonstration/1.png";
import imageThree from "../../resource/events/demonstration/5.png";
import TitleChnage from "../../Hook/TitleChnage";

const Demonstration = () => {
  TitleChnage("Demostration");

  return (
    <div className="demonstration-page inside-pages">
      <div className="right-box">
        <img
          src={imageOne}
          alt="Right Top Image"
          className="right-image"
          width={300}
        />
      </div>

      <h1 className="font-main dark-gold p-4">Event Demonstration</h1>

      <div className="test">
        <div className="p-block h5 text-bold">
          <ul className="demo-ul">
            <li className="text-left">To offer a beautiful flower</li>
            <li className="">To light a fragrant candle</li>
            <li className="text-left">To be with inner peace</li>
            <li className="">To be in the Buddha residence</li>
            <li className="text-left">We have a place</li>
            <li className="">We have our Sangha</li>
            <li className="text-left">Do you wish to see ? </li>
            <li className="">Come, Let's have a look</li>
          </ul>
        </div>
      </div>

      <div className="test mt-6 padding-sm">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/z2BwpImR2EI?si=AXqFid5RvINSR22H"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>

        <div className="mt-5">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/7m-2kH14nxY?si=JYV_U3V2c-eFVZcY"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>

        <div className="mt-5">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/0_EXJZxTMYk?si=DwTzEqpGr8iIT4AJ"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>

        <div className="mt-5"></div>

        <div className="mt-5 ">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/LH-cyC-ahHs?si=AQ5Q-o9Bf1uaYXd2"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
      </div>

      <div className="p-4 text-center mt-5">
        <img src={imageThree} alt="" width={200} />
      </div>

      <div className="bottom-box mt-5">
        <img src={imageTwo} alt="bottom-image" width={400} />
      </div>
    </div>
  );
};

export default Demonstration;
